module.exports = __webpack_public_path__ + "fonts/opensans-regular-webfont.4422cb1a.ttf";